import React from "react";
import "./DefenseNo.css";
// Defense
function DefenseNo() {
  return (
    <div className="container_defenseNo">
      <div className="defenseNo">No content.</div>
    </div>
  );
}

export default DefenseNo;
